import { Layout } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';

export const Wrap = styled(Layout.Wrap)<{ $overflow?: boolean }>`
  ${({ $overflow }) =>
    $overflow &&
    css`
      overflow: hidden;
      border: ${({ theme: { system, reference } }) =>
        `${system.fds_sys_borderwidth_S} solid ${reference.neutral.moon_400}`};
      border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
    `}
`;
